export interface IIpcService {
  /**
   * Sends an event to the electron app
   * @param channel Channel on which the event is sent
   * @param message Message or data (as JSON String) the is sent with the event.
   */
  send(channel: string, message: string): void;
}

/**
 * A service to communicate via events with an electron app.
 */
export class IpcService implements IIpcService {
  ipc: any;
  ipcAvailable = false;

  constructor() {
    try {
      //@ts-ignore
      this.ipc = window.ipcRenderer;
      this.ipcAvailable = true;
    } catch (e) {
      console.log(e);
      this.ipcAvailable = false;
    }
  }

  /**
   * Sends an event to the electron app
   * @param channel Channel on which the event is sent
   * @param message Message or data (as JSON String) the is sent with the event.
   */
  send = (channel: string, message: string): void => {
    console.log("send ipc - channel:", channel, "; message:", message);
    if (this.ipc && this.ipcAvailable) {
      this.ipc.send(channel, message);
    } else {
      console.log("send failed - No ipcRenderer");
    }
  };
}
